import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createMsalConfig } from '@/auth/MsalConfig';
import { loadRuntimeConfig } from '@/lib/runtimeConfig';
import { initAppTheme } from '@/lib/appSettings';
import App from '@/App.tsx';
import './index.css';
async function bootstrap() {
    initAppTheme();
    await loadRuntimeConfig();
    const msalInstance = new PublicClientApplication(createMsalConfig());
    await msalInstance.initialize();
    try {
        const redirectResult = await msalInstance.handleRedirectPromise();
        if (redirectResult?.account) {
            msalInstance.setActiveAccount(redirectResult.account);
            if (window.location.hash.includes('code=') ||
                window.location.hash.includes('error=')) {
                window.history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        }
    }
    catch (err) {
        const code = err && typeof err === 'object' && 'errorCode' in err
            ? String(err.errorCode)
            : '';
        if (code !== 'hash_does_not_contain_known_properties') {
            console.warn('[msal] handleRedirectPromise', err);
        }
    }
    if (!msalInstance.getActiveAccount()) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts[0]) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }
    createRoot(document.getElementById('root')).render(_jsx(StrictMode, { children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(App, {}) }) }));
}
void bootstrap();
